(() => {
  if (customElements.get('vv-motion')) return;
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  class VaVoomMotion extends HTMLElement {
    connectedCallback() {
      this.played = new WeakSet();
      this.animations = new Set();
      this.cleanup = new AbortController();
      preference.addEventListener('change', () => this.reset(), { signal: this.cleanup.signal });
      document.addEventListener('shopify:block:select', (event) => {
        if (this.contains(event.target)) this.finish();
      }, { signal: this.cleanup.signal });
      this.start();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.cleanup?.abort();
      this.finish();
    }
    finish() {
      for (const animation of this.animations || []) animation.cancel();
      this.animations?.clear();
    }
    reset() {
      this.observer?.disconnect();
      this.finish();
      this.start();
    }
    start() {
      if (preference.matches || !Element.prototype.animate || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.observer.unobserve(entry.target);
          this.reveal(entry.target);
        }
      }, { threshold: 0.08 });
      for (const element of this.querySelectorAll('[data-vv-reveal]')) {
        if (this.played.has(element)) continue;
        const box = element.getBoundingClientRect();
        if (box.bottom > 0 && box.top < window.innerHeight) {
          this.played.add(element);
          if (element.hasAttribute('data-vv-text')) this.enterText(element);
        } else {
          this.observer.observe(element);
        }
      }
    }
    enterText(element) {
      const groups = element.querySelectorAll('[data-vv-line]');
      groups.forEach((line, index) => this.run(line, [
        { transform: 'translateY(24px)', clipPath: 'inset(0 0 100% 0)' },
        { transform: 'translateY(0)', clipPath: 'inset(0 0 0 0)' }
      ], 680, index * 70));
    }
    reveal(element) {
      if (!this.isConnected || preference.matches || this.played.has(element)) return;
      this.played.add(element);
      this.run(element, [
        { opacity: 0.25, transform: 'translateY(22px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], 600, Number(element.dataset.vvDelay || 0));
    }
    run(element, frames, duration, delay) {
      const animation = element.animate(frames, {
        duration, delay, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'backwards'
      });
      this.animations.add(animation);
      animation.onfinish = () => this.animations.delete(animation);
      animation.oncancel = () => this.animations.delete(animation);
    }
  }
  customElements.define('vv-motion', VaVoomMotion);
})();
